import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Typography, Box, Link } from '@material-ui/core';
import { KailonaTable } from '@kailona/ui';
import { DocumentService } from '@kailona/core';

var DocumentsDataModule = /*#__PURE__*/function (_Component) {
  _inherits(DocumentsDataModule, _Component);

  var _super = _createSuper(DocumentsDataModule);

  function DocumentsDataModule(props) {
    var _this;

    _classCallCheck(this, DocumentsDataModule);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.fetchFiles();
    });

    _defineProperty(_assertThisInitialized(_this), "fetchFiles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var page, offset, _yield$_this$document, nextData, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              _context.prev = 1;
              page = _this.state.page + 1;
              offset = page * _this.state.rowsPerPage;
              _context.next = 6;
              return _this.documentService.fetch(offset, _this.state.rowsPerPage);

            case 6:
              _yield$_this$document = _context.sent;
              nextData = _yield$_this$document.data;
              data = [].concat(_toConsumableArray(_this.state.data), _toConsumableArray(nextData));

              _this.setState({
                loading: false,
                data: data,
                page: page
              });

              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              logger.error(_context.t0);

              _this.setState({
                loading: false
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    })));

    _this.state = {
      loading: true,
      filters: {
        dateRange: {
          begin: moment().clone().subtract(1, 'month'),
          end: moment()
        }
      },
      page: -1,
      rowsPerPage: 25,
      data: [],
      columns: [{
        label: '',
        key: 'modifiedDate',
        display: function display(row, value) {
          return moment(value).format('ddd, MMM D, YYYY, HH:mm');
        }
      }, {
        label: t('ehr', 'Name'),
        key: 'name',
        display: function display(row, value) {
          var viewFileUrl = OC.generateUrl(row.path);
          return /*#__PURE__*/React.createElement(Link, {
            href: viewFileUrl,
            target: "_blank",
            color: "primary"
          }, value);
        }
      }]
    };
    _this.documentService = new DocumentService();
    return _this;
  }

  _createClass(DocumentsDataModule, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', 'Documents')))), /*#__PURE__*/React.createElement(Box, {
        className: "content",
        mt: 3,
        style: {
          display: 'flex',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(KailonaTable, {
        data: this.state.data,
        columns: this.state.columns,
        page: this.state.page,
        rowsPerPage: this.state.rowsPerPage,
        loading: this.state.loading,
        fetchNewData: this.fetchFiles
      }))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DocumentsDataModule;
}(Component);

export { DocumentsDataModule as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DocumentsDataModule, "DocumentsDataModule", "/home/runner/html/nextcloud/apps/ehr/js/plugins/documents/src/components/DocumentsDataModule.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();